function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 36",
  transform: "translate(-1100 -5499)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 23",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(1100 5499)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon ionic-ios-sad",
  d: "M1140 5520.184a18.675 18.675 0 00-18.537 18.816 18.7 18.7 0 0018.537 18.816 18.675 18.675 0 0018.537-18.816 18.7 18.7 0 00-18.537-18.816zm-6.586 13.759a2.174 2.174 0 11-1.961 1.99 2.16 2.16 0 011.961-1.99zm-.062 13.741a1.448 1.448 0 01-1.31-2.026 8.624 8.624 0 0115.917 0 1.445 1.445 0 01-1.31 2.026 63.284 63.284 0 00-6.515-.362c-3.432 0-6.782.362-6.782.362zm13.236-9.417a2.174 2.174 0 111.961-1.99 2.16 2.16 0 01-1.961 1.99z",
  fill: "#f9cec8"
}));
var SvgFrown = function SvgFrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref);
};
export default SvgFrown;